import React, { useState } from 'react'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'
import settings from '@nobia/zeus-components/lib/settings'

import { useTranslation } from '../../../utils/useTranslation'

const Wrapper = styled.div`
  padding: ${prop('theme.body.padding')};
  margin: 0 0 0 0;
  text-align: center;
  width: 100%;
  color: ${theme('colors.primary')};
`
const Title = styled.h1`
  margin: 0 0 10px;
  padding: 0;
  font-size: ${prop('theme.font.headings.title.fontSizeSm')};
  line-height: ${prop('theme.font.headings.title.lineHeightSm')};
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    margin: 0 0 10px;
    padding: 0;
    font-size: ${prop('theme.font.headings.title.fontSizeLg')};
    line-height: ${prop('theme.font.headings.title.lineHeightLg')};
  }
`
const P = styled.p`
  font-family: ${prop('theme.font.preamble.fontFamily')};
  font-weight: ${prop('theme.font.preamble.fontWeight')};
  font-size: 18px;
  line-height: 28px;
  margin: 0 auto;
  max-width: 850px;
  display: inline-block;
  padding: 20px 0 30px;
`

const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: ${theme('colors.primary')};
  cursor: pointer;
  font-family: ${prop('theme.font.preamble.fontFamily')};
  font-weight: ${prop('theme.font.preamble.fontWeight')};
  font-size: 18px;
  text-decoration: underline;
  padding: 0;
  margin: 0 0 0 5px;

  &:hover {
    opacity: 0.8;
  }
`

const Header = () => {
  const { t } = useTranslation()
  const description = t('app.header.description')
  const [isExpanded, setIsExpanded] = useState(false)
  const isMagnetBrand = settings.brand === 'magnet'

  const getFirstSentence = (text) => {
    if (!text) return ''
    // Match the first sentence ending with . ! or ?
    const match = text.match(/^[^.!?]+[.!?]/)
    return match ? match[0].trim() : text
  }

  const firstSentence = getFirstSentence(description)
  const displayText = isExpanded ? description : firstSentence
  const showReadMore = description && description.length > firstSentence.length

  return (
    <Wrapper>
      <Title>{t('app.header.title')}</Title>
      <P>
        {isMagnetBrand ? displayText : description}
        {showReadMore && isMagnetBrand && (
          <ReadMoreButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? t('app.header.readLess') : t('app.header.readMore')}
          </ReadMoreButton>
        )}
      </P>
    </Wrapper>
  )
}

export default Header
